import {
    CREATE_ACCESSORIES_PO_FAILURE,
    CREATE_ACCESSORIES_PO_REQUEST,
    CREATE_ACCESSORIES_PO_SUCCESS,
    CREATE_USER_FORM_ACCESSORIES_PO,
    FETCH_SINGLE_ACCESSORIES_PO_FAILURE,
    FETCH_SINGLE_ACCESSORIES_PO_REQUEST,
    FETCH_SINGLE_ACCESSORIES_PO_SUCCESS,
    FETCH_ACCESSORIES_PO_FAILURE,
    FETCH_ACCESSORIES_PO_REQUEST,
    FETCH_ACCESSORIES_PO_SUCCESS,
    NAVIGATE_ACCESSORIES_PO_DETAILS,
    NAVIGATE_ACCESSORIES_PO,
    ACCESSORIES_PO_USERFORM_RESET,
    UPDATE_ACCESSORIES_PO_FAILURE,
    UPDATE_ACCESSORIES_PO_REQUEST,
    UPDATE_ACCESSORIES_PO_SUCCESS,
    DELETE_ACCESSORIES_PO_REQUEST,
    DELETE_ACCESSORIES_PO_SUCCESS,
    DELETE_ACCESSORIES_PO_FAILURE,
    RESET_ACCESSORIES_PO_INVOICE,
    SET_GRID_PAGE_INDEX_ACCESSORIES_PO,
    ACCESSORIES_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE,
    ACCESSORIES_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB,
    FETCH_ACCESSORIES_PO_INVOICE_REQUEST,
    FETCH_ACCESSORIES_PO_INVOICE_SUCCESS,
    FETCH_ACCESSORIES_PO_INVOICE_FAILURE,
    DELETE_BTN_UPDATE_API_FAILURE,
    DELETE_BTN_UPDATE_API_REQUEST,
    HEADER_SEARCH_CALL_ONLOAD,
    NAVIGATE_ACCESSORIES_PO_PRINT
} from './accessoriesPO.actionsType';

export const ACCESSORIES_PO = 'accessoriesPo';

let initialState = {
    loading: false,
    gridPageIndex: 0,
    accessoriesPO: [],
    accessoriesPoInvoice: [],
    userform: {
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldFKStyle: '',
        fldFKSaleOrder: '',
        fldIsStyleMaster: false,
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date(),
        unitId: 1
    },
    selectedAccessoriesPo: {},
    isAccessoriesPO: false,
    detailsId: [],
    activeKey: 1,
    accessoriesPOSelectedValue: null,
    errorMessage: '',
    iperrorMessage: '',
    headerSearchCall: true,
};

export let accessoriesPOReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_ACCESSORIES_PO_REQUEST:
        case CREATE_ACCESSORIES_PO_REQUEST:
        case FETCH_SINGLE_ACCESSORIES_PO_REQUEST:
        case UPDATE_ACCESSORIES_PO_REQUEST:
        case DELETE_ACCESSORIES_PO_REQUEST:
        case FETCH_ACCESSORIES_PO_INVOICE_REQUEST:
        case DELETE_BTN_UPDATE_API_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_ACCESSORIES_PO_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesPO: updatePayload
            };
        case HEADER_SEARCH_CALL_ONLOAD:
            return {
                ...state,
                loading: false,
                headerSearchCall: payload
            }
        case CREATE_ACCESSORIES_PO_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: updatePayload
            };

        case FETCH_ACCESSORIES_PO_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesPoInvoice: updatePayload
            };
        case FETCH_SINGLE_ACCESSORIES_PO_SUCCESS:

            return {
                ...state,
                loading: false,
                selectedAccessoriesPo: updatePayload,
                userform: {
                    ...updatePayload,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId

                }

            };
        case UPDATE_ACCESSORIES_PO_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedAccessoriesPo: {},
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: []
            };
        case DELETE_ACCESSORIES_PO_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                },
                selectedAccessoriesPo: {},
                detailsId: []
            };
        case FETCH_ACCESSORIES_PO_FAILURE:
        case FETCH_SINGLE_ACCESSORIES_PO_FAILURE:
        case CREATE_ACCESSORIES_PO_FAILURE:
        case UPDATE_ACCESSORIES_PO_FAILURE:
        case DELETE_ACCESSORIES_PO_FAILURE:
        case FETCH_ACCESSORIES_PO_INVOICE_FAILURE:
        case DELETE_BTN_UPDATE_API_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_ACCESSORIES_PO:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case SET_GRID_PAGE_INDEX_ACCESSORIES_PO:
            return {
                ...state,
                gridPageIndex: payload
            };
        case ACCESSORIES_PO_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldFKStyle: '',
                    fldFKSaleOrder: '',
                    fldIsStyleMaster: false,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                selectedAccessoriesPo: {},
                detailsId: [],
                activeKey: 1
            };
        case RESET_ACCESSORIES_PO_INVOICE:
            return {
                ...state,
                accessoriesPoInvoice: []
            };
        case NAVIGATE_ACCESSORIES_PO_DETAILS:
            return {
                ...state,
                isAccessoriesPO: true,
                loading: false,
                accessoriesPOSelectedValue: updatePayload.accessoriesPOSelectedValue
            };
        case NAVIGATE_ACCESSORIES_PO:
            return {
                ...state,
                isAccessoriesPO: false
            };
        case NAVIGATE_ACCESSORIES_PO_PRINT:
            return {
                ...state,
                isAccessoriesPO: false,
                accessoriesPOSelectedValue: updatePayload.accessoriesPOSelectedValue
            };
        case ACCESSORIES_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                activeKey: 2
            };
        case ACCESSORIES_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE:
            return {
                ...state,

                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsStyleMaster: false,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                activeKey: 1
            };
        default:
            return state;
    }
};
